export default __webpack_public_path__ + "93409993b141beb27452e91967e301cf.png";